/**
 * @generated SignedSource<<1ab46e61f882ee985cef69c0fff00288>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUnlockAllSlotsMutation$variables = Record<PropertyKey, never>;
export type useUnlockAllSlotsMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly slots: ReadonlyArray<{
      readonly id: string;
    } | null | undefined> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useUnlockAllSlotsMutation = {
  response: useUnlockAllSlotsMutation$data;
  variables: useUnlockAllSlotsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSlot",
  "kind": "LinkedField",
  "name": "slots",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnlockAllSlotsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "UnlockAllTimeSlotsPayload",
        "kind": "LinkedField",
        "name": "unlockAllTimeSlots",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUnlockAllSlotsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "UnlockAllTimeSlotsPayload",
        "kind": "LinkedField",
        "name": "unlockAllTimeSlots",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b57ddc5be7d8ef934c1fcfe388818303",
    "id": null,
    "metadata": {},
    "name": "useUnlockAllSlotsMutation",
    "operationKind": "mutation",
    "text": "mutation useUnlockAllSlotsMutation {\n  responsePayload: unlockAllTimeSlots {\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n    success\n    slots {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a9821e58fa5303ad3426c7b5c8545c7";

export default node;
